import { URLS } from "../../env/urls";
import { sendServerRequest } from "../../server/request";

export async function waSendAudio(chatId:number,audio:Blob){
   const form=new FormData();
   form.append('chatId',String(chatId));
   form.append('audio',audio,'audio.webm');
   await sendServerRequest('POST',URLS.wa.sendAudio,form);
}
